/**
 * RoleBasedRoute Component
 * Conditionally renders different components based on user role
 * Used for showing mobile-optimized views for delivery users
 */

import React from 'react';
import { useIsDeliveryUser } from '../../hooks/useUserRole';

interface RoleBasedRouteProps {
  /** Component to render for delivery users */
  deliveryComponent: React.ReactNode;
  /** Component to render for all other users */
  defaultComponent: React.ReactNode;
}

export const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({
  deliveryComponent,
  defaultComponent
}) => {
  const isDeliveryUser = useIsDeliveryUser();
  
  if (isDeliveryUser) {
    return <>{deliveryComponent}</>;
  }
  
  return <>{defaultComponent}</>;
};

RoleBasedRoute.displayName = 'RoleBasedRoute';
